module.exports = __webpack_public_path__ + "static/media/NFFC.1a31138e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/desktop/NFFC.svg
// module id = 112
// module chunks = 0